import client from './client';

export const alertAppsApi = {
  async listApps() {
    const { data } = await client.get('/api/alert-apps');
    return data;
  },

  async getApp(id) {
    const { data } = await client.get(`/api/alert-apps/${id}`);
    return data;
  },

  async createApp(appData) {
    const { data } = await client.post('/api/alert-apps', appData);
    return data;
  },

  async updateApp(id, appData) {
    const { data } = await client.patch(`/api/alert-apps/${id}`, appData);
    return data;
  },

  async deleteApp(id) {
    const { data } = await client.delete(`/api/alert-apps/${id}`);
    return data;
  },

  async listApiKeys(appId) {
    const { data } = await client.get(`/api/alert-apps/${appId}/api-keys`);
    return data;
  },

  async createApiKey(appId, payload) {
    const { data } = await client.post(`/api/alert-apps/${appId}/api-keys`, payload);
    return data;
  },

  async deleteApiKey(appId, keyId) {
    const { data } = await client.delete(`/api/alert-apps/${appId}/api-keys/${keyId}`);
    return data;
  },
};
